import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import AxiosRequest from '../axiosComponent/allAxiosCommonRequest';
const MyBillingParty = ({
    field: { name, value, dataId },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        AxiosRequest({
            url: `masters/billing_party`,
            method: 'get',
            getValues: false
        }).then((response) => {
            console.log(response)
            setcontent(response.data.resultSet)
            setloading(false)
        })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.billingPartyId
            temp.text = `${object.billingPartyName} (${object.billingPartyCode})`
            temp.value = object.billingPartyCode
            temp.id = object.billingPartyId
            return options[index] = temp
        })
    }

    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        let info = data.options
        if (info.length > 0) {
            let id = info.filter(args => args.value == data.value)
            setFieldValue(props.dataId, id[0].id)
        }
    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyBillingParty